export default "/images/search-icon.svg?5acf16cc9ab64d416750c8a457738560";